import { h, Component } from 'preact';
import styles from './form_row_style';

import FormField from './form_field';
import SubmitButton from './submit_button';

export default class FormRow extends Component {
	render({row, responses, submitting, fieldTypeRenderer},{}) {
		return (
			<div class="flexRow">
				{ row.fields.map( field => {
					if (field.type === "submit") return <SubmitButton field={field} submitting={this.props.submitting} />
        	return <FormField field={field} validateAndStoreField={this.props.validateAndStoreField} responses={responses} fieldTypeRenderer={fieldTypeRenderer} />
				}) }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/src/components/form/form_row.js